import { useEffect } from 'react';

/**
 * Route-scoped loader for the CampaignOS web fonts (Hanken Grotesk, JetBrains
 * Mono, Material Symbols Outlined). Exact URLs from
 * D:\campaigning-system\index.html.
 *
 * Why route-scoped rather than a global <link> in index.html: these fonts are
 * used ONLY by the Campaigning Tool. Loading them globally would add three
 * font requests (incl. the ~1MB Material Symbols variable font) to every other
 * page in VMS for zero visual benefit there. Injecting on mount keeps the
 * network cost where the fonts are actually used. Links are id-guarded so they
 * insert once and are shared across re-mounts / both tabs; we intentionally do
 * NOT remove them on unmount so re-entering the tool has no flash-of-unstyled-
 * text and the browser cache is reused.
 */
const FONT_LINKS = [
  { id: 'cos-font-preconnect-1', rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { id: 'cos-font-preconnect-2', rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  {
    id: 'cos-font-hanken-jetbrains',
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600&display=swap',
  },
  {
    id: 'cos-font-material-symbols',
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200',
  },
];

export function useCampaignFonts() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    FONT_LINKS.forEach(({ id, rel, href, crossOrigin }) => {
      if (document.getElementById(id)) return;
      const link = document.createElement('link');
      link.id = id;
      link.rel = rel;
      link.href = href;
      if (crossOrigin) link.crossOrigin = crossOrigin;
      document.head.appendChild(link);
    });
  }, []);
}

export default useCampaignFonts;
